export default "__VITE_ASSET__B3H$RHhs__"